import { create } from "zustand";
import { initialLeitenLoading } from "../interfaces/ILeitenLoading";
/* eslint-disable @typescript-eslint/no-explicit-any */
export const useLeitenRequestStore = create(() => ({}));
export const leitenMap = (keys, selector) => {
    return (state) => selector(keys.map((key) => state[key] || initialLeitenLoading()));
};
// export const selector = leitenMap(
//   ["1", "2"],
//   ([state1, state2]) => ({loading: state1.status === "loading" && state2.status === "loading", status: state2.status}),
// );
// const { loading, status } = useLeitenRequests(selector);
// const a = () => {
//   const status = useLeitenRequest(selector);
//   const status = userController.useRequest(state => state.status);
